export default function ({ store, redirect }) {
  // Redirect to kitchen page if current user is chef
  if (process.client && store.state.staff.currentRole === 'Chef') {
    return redirect('/kitchen')
  }
}
